import type { JPushNotificationData } from './jpush'

export type { JPushNotificationData }

// Web stub: jpush-react-native is native-only. The .web extension keeps it out of the web
// bundle entirely, so these are inert counterparts to the exports consumers rely on.
export async function getJPushRegistrationID(): Promise<string | null> {
  return null
}

export function initAndListenRegistrationID(_callback: (registrationID: string) => void): () => void {
  return () => {}
}

export function addJPushNotificationListener(_callback: (data: JPushNotificationData) => void): () => void {
  return () => {}
}
